import { Box } from "@mui/system";
import BudgetDateFilter from "./BudgetContent/BudgetDateFilter";
import BudgetSearchItems from "./BudgetContent/BudgetSearchItems";
import BudgetSearchFilter from "./BudgetContent/BudgetSearchFilter";

const Budget = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <BudgetDateFilter />
        <BudgetSearchFilter />
        <BudgetSearchItems />
      </Box>
    </>
  );
};

export default Budget;
